console.error('`effector-react/scope` is deprecated. Use `effector-react` directly instead')
export * from '../../src/react/ssr'
export {Provider} from '../../src/react/scope'
